import React from 'react'
import './about.css'
export default function about() {
  return (
    <div className='about'>
        <h1>Welcome to Samraj Solar Engines</h1>
        <br></br>
      <p> Powering a Greener Tomorrow At Samrat Solar, we’re committed to providing sustainable, reliable, and cost-effective solar energy solutions for residential, commercial, and industrial needs. With the rising global demand for clean energy, we believe it’s our responsibility to deliver high-quality solar products and services that are not only efficient but also environmentally friendly. Our mission is to lead the transition toward renewable energy, one installation at a time.</p>
      
      {/*images below the content*/}
      <div className='c1'>
        <img src='./img4.jpg' alt='' className='image'/>
      </div>
      <h1>What We Do?</h1>
      <p>At Samraj Solar Engines, we specialize in end-to-end solar power solutions,Our services include:</p>
      <li>Solar Panel Installation: We provide customized installation services tailored to meet the specific needs of our clients, ensuring maximum energy production and minimal environmental impact.</li> 
    <br></br>
    <li>System Design & Engineering: Our team of experienced engineers and designers works closely with clients to create efficient, durable, and scalable solar systems.</li>
    <br></br>

    {/*images below the content*/}
    <div className='c1'>
        <img src='./img5.jpg' alt='' className='image'/>
      </div>

    <h1>Why Choose Solar Energy?</h1>
    <p>Solar energy offers a host of benefits, making it one of the most sustainable energy options available today. Here’s why switching to solar with Samrat Solar is a smart investment:</p>
    <li>Cost Savings: With solar power, you can drastically reduce or even eliminate your electricity bills. By harnessing the sun’s energy, you’re essentially generating free electricity, offsetting traditional power costs.</li>
    <br></br>
    <li>Environmental Impact: Solar energy is renewable, clean, and produces no harmful emissions. Unlike fossil fuels, solar power reduces carbon footprints, helping to combat climate change and promote a healthier planet.</li>
    <br></br>
    <li>Energy Independence: Solar power reduces dependency on traditional energy sources, which are subject to price fluctuations and supply constraints. By generating your own electricity, you gain greater control over your energy supply and costs.</li>
    <br></br>
    <li>Low Maintenance Costs: Solar systems are designed to be durable and require minimal maintenance. With regular checks, they can last 25 years or more, offering long-term savings and reliability.</li>
    <br></br>
    <hr/>
    <h1>Our Managing director:</h1>
    <div className='c2'>
      <div className='c2left'>
        <p><b>Aburi Ajay Kumar</b> has been awarded with Galileo Mater Cerrtification and other Certifications in the solar Application.As a young entrepreneur and willing to bring Solar applications into the forefront
        ,he has built a team comprising industry experienced professinals and other Fresh Graduates and Diploma Holders.</p>
        <br/>
        <p>Solar Energy is the Most Dependable energy source of the futher.We aim to tap and utilize this energy by develping ,bulding and operating solar plants and system of different multi-watt ranges as per your requirements.</p>
      </div>
      <div className='c2right'>
        <img className='img' src='./img15.jpeg' alt=''/>
      </div>
    </div>
    <br/>
    </div>
  )
}
